export default "__VITE_ASSET__CIzJWgm8__"